const baseRadius = {
  1: '3px',
  2: '4px',
  3: '6px',
  4: '8px',
  5: '12px',
  6: '16px',
};

const radiusScales = {
  none: {
    factor: '0',
    full: '0px',
    thumb: '0.5px',
  },
  small: {
    factor: '0.75',
    full: '0px',
    thumb: '0.5px',
  },
  medium: {
    factor: '1',
    full: '0px',
    thumb: '9999px',
  },
  large: {
    factor: '1.5',
    full: '0px',
    thumb: '9999px',
  },
  full: {
    factor: '1.5',
    full: '9999px',
    thumb: '9999px',
  },
};

export type RadiusKey = keyof typeof radiusScales;
export type BaseRadiusKey = keyof typeof baseRadius;
export type RadiusScale = (typeof radiusScales)[RadiusKey];
export type ComputedRadius = Record<RadiusKey, RadiusScale & Record<BaseRadiusKey, string>>;

export const radius: ComputedRadius = Object.fromEntries(
  Object.entries(radiusScales).map(([scale, values]) => [
    scale,
    {
      factor: values.factor,
      full: values.full,
      thumb: values.thumb,
      ...Object.fromEntries(
        Object.entries(baseRadius).map(([key, value]) => [
          key,
          `calc(${value} * ${values.factor})`,
        ]),
      ),
    },
  ]),
) as ComputedRadius;
